<template>
  <span v-if="showIcon" v-tooltip="tooltip">
    <FaIcon :icon="['fas', ICON.INTRUSION_PANEL]" :class="iconClass" />
  </span>
  <span v-else-if="showLabel">
    {{ status.label }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { ICON } from '@/constants/icons';
import type { qx_eDeviceConnectionStatus_enum } from '@/graphql/types';
import { getIntrusionStatus } from '@/views/intrusion/utilities/intrusion-status';

import { iconColorClass, smartIconTooltip } from './smart-icon-helpers';

const props = withDefaults(
  defineProps<{
    panel:
      | {
          enabled?: boolean;
          connectionStatus?: qx_eDeviceConnectionStatus_enum | null;
          gatewayConnected?: boolean | null;
          gateway?: {
            connectionStatus?: boolean | null;
          } | null;
        }
      | null
      | undefined;
    type?: 'icon' | 'label';
  }>(),
  {
    type: 'icon'
  }
);

const status = computed(() => getIntrusionStatus(props.panel));

const iconClass = computed(() => iconColorClass(status.value.color));

const tooltip = computed(() => {
  if (!status.value.label) {
    return false;
  }

  return smartIconTooltip(`Intrusion: ${status.value.label}`);
});

const showIcon = computed(() => props.type === 'icon');
const showLabel = computed(() => props.type === 'label');
</script>
